<app-rc-dialog-wrapper (closePopin)="closePopin()">
  <div class="product-detail-wrapper">
    <div class="product-detail">
      <!-- Left content on the popin -->
      @if (product) {
        <div class="product-detail-product">
          <app-product-card
            class="product-detail-card"
            [showSelectButton]="showSelectButton"
            [selectButtonLabel]="selectButtonLabel"
            [showRetailPrices]="!isStandalone"
            [disableDetailsButton]="data?.disableDetailsButton"
            [product]="product"
            [packId]="data?.packId"
            [displayPackages]="!isStandalone"
            [selectedProductsIds]="selectedProductsIds"
            (selectProduct)="onSelectProduct($event)"
            (removeProduct)="onRemoveProduct($event)"
          ></app-product-card>
        </div>
      }

      <!-- Right content on the popin -->
      <div class="product-detail-nav">
        @if (product) {
          <!-- Product Section: Main benefits -->
          <div class="product-detail-section" [class.extended]="currentSection === 1">
            <!-- Product Section header -->
            <div class="section-header section-first-header" (click)="showMoreDetail(1, $event)">
              <h2 class="rc-title-beta rc-title--right-icon">
                <span class="product-detail-section__header--text" i18n="@@dialog-product-detail_benefit-label">Main benefits</span>
                <em class="rc-icon rc-icon--arrow-down" [class.active]="currentSection === 1"></em>
              </h2>
            </div>
            <!-- Product Detail -->
            @if (product.benefits?.length > 0) {
              <div class="section-detail">
                <!-- Product detail: Skin Barrier -->
                @for (benefit of product.benefits; track benefit.id || benefit.title) {
                  <div class="section-detail-item">
                    <div class="section-detail-header">
                      <img class="section-detail-icon" [src]="benefit.image || placeholderBenefitImage" [alt]="benefit.title || ''" />
                      <p class="section-detail-title">
                        {{ benefit.title?.toUpperCase() }}
                      </p>
                    </div>
                    <p class="section-detail-text">
                      {{ benefit.description }}
                    </p>
                  </div>
                }
              </div>
            } @else {
              <div class="section-detail">
                <span>--</span>
              </div>
            }
          </div>
          <!-- Product Section: Description -->
          @if (product.description?.length > 0) {
            <div class="product-detail-section" [class.extended]="currentSection === 2">
              <!-- Product Section header -->
              <div class="section-header" (click)="showMoreDetail(2, $event)">
                <h2 class="rc-title-beta rc-title--right-icon">
                  <span class="product-detail-section__header--text" i18n="@@dialog-product-detail_description-label">Description</span>
                  <em class="rc-icon rc-icon--arrow-down" [class.active]="currentSection === 2"></em>
                </h2>
              </div>
              <!-- Product Detail -->
              <div class="section-detail">
                @for (descriptionItem of product.description; track descriptionItem) {
                  <p class="section-detail-item">
                    {{ descriptionItem }}
                  </p>
                }
              </div>
            </div>
          }
          <!-- Product Section: Ingredients -->
          <div class="product-detail-section" [class.extended]="currentSection === 3">
            <!-- Product Section header -->
            <div class="section-header" (click)="showMoreDetail(3, $event)">
              <h2 class="rc-title-beta rc-title--right-icon">
                <span class="product-detail-section__header--text" i18n="@@product-book_product_information">Product Information</span>
                <em class="rc-icon rc-icon--arrow-down" [class.active]="currentSection === 3"></em>
              </h2>
            </div>
            <!-- Product Detail -->
            <div class="section-detail">
              @for (compositionItem of product.composition; track compositionItem) {
                <p class="section-detail-item">
                  {{ compositionItem }}
                </p>
              }
            </div>
          </div>
        }
      </div>
    </div>
    @if (showWholesalePrices$ | async) {
      <span>
        {{ 'rc-table_b2b-price-de-ch-precision' | translateKey }}
      </span>
    }
  </div>
</app-rc-dialog-wrapper>
